import { ProForm } from "@ant-design/pro-components";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { CustomButton, CustomCard, CustomInput, toast } from "../../../../../../components";
import { useModal } from "../../../../../../context/ModalContext";
import { apiCodeEnum } from "../../../../../../enumerations/signInUpEnum";
import { reset } from "../../../../../../plugins/utils";
import { usePostGift } from "../../../../hooks/index.hook";
import styles from "./style.module.scss";
import "./style.scss";

const Gift = () => {
  const { t } = useTranslation();
  const formRef = useRef();
  const { openTipsModal } = useModal();

  const { mutate: postGift, isLoading } = usePostGift();

  const handleFinish = () => {
    const params = formRef.current.getFieldsValue();

    postGift(
      {
        ...params,
      },
      {
        onSuccess: (success) => {
          const { code, msg } = success?.data;
          if (code === apiCodeEnum.ERROR) {
            openTipsModal({
              body: msg,
            });
            return;
          }
          toast({ content: msg, type: "success" });
          reset(formRef);
        },
        onError: () => {},
      },
    );
  };

  return (
    <CustomCard title={t("normal.gift")}>
      <ProForm
        formRef={formRef}
        submitter={{
          render: () => (
            <CustomButton
              buttonStyle={`${styles.customButtonStyle}`}
              type={"submit"}
              loading={isLoading}
            >
              {t("normal.exchange.upper")}
            </CustomButton>
          ),
        }}
        onFinish={handleFinish}
        className="gift-from"
      >
        <CustomInput
          name="batch"
          placeholder={t("normal.pleaseEnter", { label: t("user.gift.code") })}
        />
      </ProForm>
    </CustomCard>
  );
};

export default Gift;
